import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { TABS } from './adminTabs';

const AdminSidebar = ({ activeTab, onSelect, openGroups, setOpenGroups }) => (
  <aside className="bg-white border-r border-gray-200 py-4">
    <nav className="space-y-1 px-2">
      {TABS.map((t) => {
        if (t.isGroup) {
          const childActive = t.children.some((c) => c.key === activeTab);
          const isOpen = openGroups[t.key] ?? childActive;
          return (
            <div key={t.key}>
              <button
                onClick={() => setOpenGroups((prev) => ({ ...prev, [t.key]: !isOpen }))}
                className={`w-full flex items-center justify-between gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
                  childActive ? 'text-[#ee5e23] font-semibold' : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span className="flex items-center gap-2">
                  <t.icon className="w-4 h-4" />
                  {t.label}
                </span>
                {isOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
              </button>
              {isOpen && (
                <div className="ml-3 mt-1 space-y-0.5 border-l border-gray-200 pl-2">
                  {t.children.map((c) => (
                    <button
                      key={c.key}
                      onClick={() => onSelect(c.key)}
                      className={`w-full flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
                        activeTab === c.key
                          ? 'bg-[#ee5e23]/10 text-[#ee5e23] font-semibold'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      <c.icon className="w-3.5 h-3.5" />
                      {c.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        }
        return (
          <button
            key={t.key}
            onClick={() => onSelect(t.key)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
              activeTab === t.key
                ? 'bg-[#ee5e23]/10 text-[#ee5e23] font-semibold'
                : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </button>
        );
      })}
    </nav>
  </aside>
);

export default AdminSidebar;
